import React, { ReactNode } from 'react'
import { Coords } from 'google-map-react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

import * as styles from './styles.module.scss'

import marker from '../../2021/images/marker.svg'

interface MarkerProps extends Coords {
	content?: ReactNode
	markerImg?: string
	bestseller?: boolean
	url?: string
}

const Marker: React.FC<MarkerProps> = ({
	bestseller = false,
	content,
	url,
	markerImg
}) => {
	if (bestseller) {
		return (
			<Tippy content={content}>
				<a href={url} className={styles.bestsellerMarker} target="_blank">
					<img src={markerImg} alt="" className={styles.bestsellerImg} />
				</a>
			</Tippy>
		)
	}

	return (
		<Tippy content={content}>
			<img src={markerImg ?? marker} alt="" className={styles.marker} />
		</Tippy>
	)
}

export default Marker
